import useStockRemovalsTable from "./useStockRemovalsTable";
import secondaryComponents from "..";

const StockRemovalsTable = ({
  stockRemovals = [],
  metaDetails = {},
  gotoPage = () => {},
  refetch = () => {},
  onContinueDraft = () => {},
}) => {
  const {
    instance,
    previewImage,
    setPreviewImage,
    requestToDelete,
    setRequestToDelete,
    handleDelete,
    isDeleting,
  } = useStockRemovalsTable({
    stockRemovals,
    refetch,
    onContinueDraft,
  });

  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <h4 className="pt-5 text-center">No Stock Removal Requests Found</h4>
      </secondaryComponents.TableHelper>

      {/* Pagination */}
      {stockRemovals?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      {/* Evidence Image Preview Modal */}
      <secondaryComponents.Modal
        isActive={Boolean(previewImage)}
        closeModal={() => setPreviewImage(null)}
        width="550px"
      >
        <div style={{ textAlign: "center", padding: "16px" }}>
          <h5 className="mb-3">Evidence Preview</h5>
          <img
            src={previewImage}
            alt="Evidence"
            style={{
              maxWidth: "100%",
              maxHeight: "75vh",
              objectFit: "contain",
              borderRadius: "8px",
            }}
          />
        </div>
      </secondaryComponents.Modal>

      {/* Delete Confirmation Modal */}
      <secondaryComponents.ConfirmDialog
        title="Delete Stock Removal Request"
        isOpen={Boolean(requestToDelete)}
        setIsOpen={() => setRequestToDelete(null)}
        handler={() => handleDelete(requestToDelete)}
        isLoading={isDeleting}
      >
        <p style={{ color: "#718096", textAlign: "center" }} className="mb-0">
          Are you sure you want to delete this removal request? This action
          cannot be undone.
        </p>
      </secondaryComponents.ConfirmDialog>
    </>
  );
};

export default StockRemovalsTable;
